import { useQuery } from '@tanstack/react-query';
import { getAllReports } from 'Services';
import { RQ_ALL_REPORTS } from 'Utils';
import { transformReports } from '../helper';

function useReports(type: ReportType, users?: UsersHashmap) {
    return useQuery([RQ_ALL_REPORTS, type], () => getAllReports(type), {
        select: (reportsData) => {
            return transformReports(reportsData, users);
        }
    });
}

export default useReports;
